/* eslint-disable react/no-multi-comp */
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom'; // Import useLocation

import { NavigationListItem } from './components';

const NavigationList = (props) => {
  const { pages, isMenuCollapse, ...rest } = props;
  
  return (
    <>
      {pages.reduce(
        (items, page, index) => reduceChildRoutes({ items, page, isLastItem: index === pages.length - 1, isMenuCollapse, ...rest }),
        []
      )}
    </>
  );
};

NavigationList.propTypes = {
  depth: PropTypes.number,
  pages: PropTypes.array,
};

const reduceChildRoutes = (props) => {
  const { location, items, page, depth, isLastItem, isMenuCollapse} = props;

   
  // Check if the current pathname includes the page's href
  const open = location.pathname.includes(page.href);

  if (page.children) {

   
    items.push(
      <NavigationListItem
        depth={depth}
        key={page.title}
        label={page.label}
        open={open}
        title={page.title}
        pageid={page.id}
        code={page.object_code}
        isLastItem={isLastItem}
        menuIcon={page.menu_icon}
        isMenuCollapse={isMenuCollapse}
      >
        <NavigationList depth={depth + 1} pages={page.children} location={location} isMenuCollapse={isMenuCollapse} />
      </NavigationListItem>
    ); 
  } else { 
    items.push(
    
      <NavigationListItem
        depth={depth}
        href={page.href}
        key={page.title}
        label={page.label}
        title={page.title}
        pageid={page.id}
        isLastItem={isLastItem}
        menuIcon={page.menu_icon}
        isMenuCollapse={isMenuCollapse}
      />
    );
  }

  return items;
};

const Navigation = (props) => {
  const { pages, component: Component, isMenuCollapse, ...rest } = props;
  const location = useLocation(); // Use useLocation to get current pathname

  return (
    <Component {...rest} >
      <NavigationList depth={0} pages={pages} isMenuCollapse={isMenuCollapse} location={location} />
    </Component>
  );
};

Navigation.propTypes = {
  className: PropTypes.string,
  component: PropTypes.any,
  pages: PropTypes.array.isRequired,
  title: PropTypes.string,
};

Navigation.defaultProps = {
  component: 'div',
};

export default Navigation;
